import React, {Component} from "react";
import {Link} from "react-router-dom";

class BannerTwo extends Component {
    render() {
        return (
            <div className="owl-carousel banner-carousel">
                <div className="cm-banner overlay bg-cover" style={{backgroundImage: "url(assets/images/bg-banner-02.jpg)", backgroundPosition: "center", width: "100%", height: "75vh", margin:"0 auto", backgroundSize: "cover"}}>
                    <div className="container h-100">
                        <div className="row h-100 align-items-center justify-content-center">
                            <div className="col-xl-6 col-lg-7">
                                <div className="block text-white text-center">
                                    <h3 className="mb-15">Mobile & Computer</h3>
                                    <h2 className="display-3">Repair Service</h2>
                                    <p className="lead mt-25 mb-35">From heavy-duty workstations to phones, no device is too big or small for us!</p>
                                    <Link className="btn btn-primary mt-10 mr-3 mr-md-4 initiate-scripts" to={'/contact'}>Appointment</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cm-banner overlay bg-cover" style={{backgroundImage: "url(assets/images/apple-logo.png)", backgroundPosition: "center", width: "100%", height: "75vh", margin:"0 auto", backgroundSize: "cover"}}>
                    <div className="container h-100">
                        <div className="row h-100 align-items-center justify-content-center">
                            <div className="col-xl-6 col-lg-7">
                                <div className="block text-white text-center">
                                    <h3 className="mb-15">Laptop & Mac</h3>
                                    <h2 className="display-3">Repair Service</h2>
                                    <p className="lead mt-25 mb-35">We repair laptops of any variety! Got a Mac? Our Apple Certified Technicians will make sure it gets the care it deserves.</p>
                                    <Link className="btn btn-primary mt-10 mr-3 mr-md-4 initiate-scripts" to={'/contact'}>Appointment</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BannerTwo;